if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.currentImageIndex = 0;
      this.galleryMedia = [];
      this.isNavigating = false; // Prevent double navigation
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      // Clean up modal-specific event listeners
      this.removeModalEventListeners();

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const dtLoader = document.createElement('div');
      dtLoader.className = 'dT_loading';
      dtLoader.innerHTML = `<div class="loading"></div>`;
      
      setTimeout( () => {
        $('.quick-add-modal[open]').find('.main-product_info').addClass('quick-add-modal-in-progress');
      }, 2000);
      
      setTimeout( () => {
        $('.main-product_info').removeClass('quick-add-modal-in-progress');
      }, 4000);
      
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          
          // Extract media data from the fetched page before processing
          this.extractMediaData(responseHTML);
          
          this.preventDuplicatedIDs();        
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();         
          this.preventVariantURLSwitching();
          
          // Initialize modal-specific gallery functionality
          this.initializeModalGallery();
          
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');   
        });
    }

    // Extract media data from the fetched product page
    extractMediaData(responseHTML) {
      console.log('🔍 Starting media extraction...');
      
      try {
        // Look for the script tag containing media data
        const scripts = responseHTML.querySelectorAll('script');
        let mediaItems = [];
        let featuredMedia = null;
        
        console.log(`Found ${scripts.length} script tags`);
        
        scripts.forEach((script, index) => {
          const content = script.textContent || script.innerText;
          
          // More flexible patterns to match your actual script
          if (content.includes('mediaItems') && content.includes('featuredMedia')) {
            console.log(`📄 Found gallery script in script tag ${index}`);
            
            // Try different patterns
            const mediaPatterns = [
              /const mediaItems = (\[.*?\]);/s,
              /mediaItems = (\[.*?\]);/s,
              /let mediaItems = (\[.*?\]);/s,
              /var mediaItems = (\[.*?\]);/s
            ];
            
            const featuredPatterns = [
              /const featuredMedia = ({.*?});/s,
              /featuredMedia = ({.*?});/s,
              /let featuredMedia = ({.*?});/s,
              /var featuredMedia = ({.*?});/s,
              /const featuredMedia = (null);/s
            ];
            
            for (let pattern of mediaPatterns) {
              const match = content.match(pattern);
              if (match) {
                console.log('📸 Found media items:', match[1]);
                mediaItems = JSON.parse(match[1]);
                break;
              }
            }
            
            for (let pattern of featuredPatterns) {
              const match = content.match(pattern);
              if (match) {
                console.log('⭐ Found featured media:', match[1]);
                if (match[1] !== 'null') {
                  featuredMedia = JSON.parse(match[1]);
                }
                break;
              }
            }
          }
        });
        
        console.log('📊 Media extraction results:', {
          mediaItemsCount: mediaItems.length,
          featuredMedia: featuredMedia ? 'Found' : 'None'
        });
        
        // Fallback: try to extract from existing DOM elements
        if (mediaItems.length === 0) {
          console.log('🔄 Trying DOM fallback method...');
          const galleryImages = responseHTML.querySelectorAll('[data-media-id]');
          galleryImages.forEach(img => {
            const mediaSrc = img.src || img.dataset.src;
            if (mediaSrc) {
              mediaItems.push({
                id: img.dataset.mediaId,
                src: mediaSrc,
                alt: img.alt || '',
                preview_image: { src: mediaSrc }
              });
            }
          });
          console.log(`Found ${mediaItems.length} media items from DOM`);
        }
        
        // Set up media array - DON'T put featured media first, keep original order
        this.galleryMedia = [...mediaItems];
        
        console.log('✅ Final gallery media array (keeping original order):', this.galleryMedia);
        console.log('📋 Media IDs in order:', this.galleryMedia.map(m => m.id));
        
      } catch (error) {
        console.error('❌ Error extracting media data:', error);
        this.galleryMedia = [];
      }
    }

    // Initialize gallery functionality for the modal
    initializeModalGallery() {
      // Wait a bit for DOM to be fully ready
      setTimeout(() => {
        this.setupGalleryImages();
        this.bindGalleryEvents();
      }, 100);
    }

    setupGalleryImages() {
      console.log('🖼️ Setting up gallery images...');
      console.log('Gallery media count:', this.galleryMedia.length);
      
      if (this.galleryMedia.length === 0) {
        console.log('❌ No gallery media found');
        return;
      }

      // Find which image is currently shown by looking at thumbnails
      const activeThumbnail = this.modalContent.querySelector('.thumbnail-item.active');
      let startIndex = 0;
      
      if (activeThumbnail) {
        startIndex = parseInt(activeThumbnail.dataset.mediaIndex) || 0;
        console.log('🎯 Found active thumbnail at index:', startIndex);
      }
      
      // Set the currently active image
      const currentMedia = this.galleryMedia[startIndex];
      console.log('Current media:', currentMedia);
      
      if (currentMedia) {
        const imageSrc = currentMedia.preview_image 
          ? currentMedia.preview_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_800x.$1')
          : currentMedia.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_800x.$1');

        console.log('Image src:', imageSrc);

        const mainImage = this.modalContent.querySelector('#main-gallery-image');
        console.log('Main image element:', mainImage);
        
        if (mainImage) {
          mainImage.src = imageSrc;
          mainImage.alt = currentMedia.alt || '';
          console.log('✅ Main image updated');
        } else {
          console.log('❌ Main image element not found');
          // Try alternative selectors
          const altImage = this.modalContent.querySelector('.product__media img');
          console.log('Alternative image element:', altImage);
          if (altImage) {
            altImage.src = imageSrc;
            altImage.alt = currentMedia.alt || '';
            console.log('✅ Alternative image updated');
          }
        }
      }

      this.currentImageIndex = startIndex;
      console.log('✅ Gallery setup complete, starting at index:', startIndex);
      
      // Log thumbnail mapping for debugging
      const thumbnails = this.modalContent.querySelectorAll('.thumbnail-item');
      console.log('🔗 Thumbnail mapping:');
      thumbnails.forEach((thumb, i) => {
        const dataIndex = thumb.dataset.mediaIndex;
        console.log(`  Thumbnail ${i}: data-media-index="${dataIndex}"`);
      });
    }

    bindGalleryEvents() {
      console.log('🔗 Binding gallery events...');
      
      // First, remove any existing onclick handlers to prevent conflicts
      const allClickableElements = this.modalContent.querySelectorAll('[onclick*="navigateGallery"]');
      allClickableElements.forEach(el => {
        el.removeAttribute('onclick');
        console.log('🗑️ Removed onclick from:', el);
      });
      
      // Bind thumbnail clicks
      const thumbnails = this.modalContent.querySelectorAll('.thumbnail-item');
      console.log(`Found ${thumbnails.length} thumbnails`);
      
      thumbnails.forEach((thumbnail, index) => {
        // Remove any existing onclick handlers
        thumbnail.removeAttribute('onclick');
        
        console.log(`Binding click to thumbnail ${index}:`, thumbnail);
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('👆 Thumbnail clicked:', index);
          
          const mediaIndex = parseInt(thumbnail.dataset.mediaIndex) || index;
          const media = this.galleryMedia[mediaIndex];
          
          if (media) {
            console.log('🖼️ Switching to media:', media);
            const imageSrc = media.preview_image ? 
              media.preview_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_800x.$1') :
              media.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_800x.$1');
            
            this.setActiveImage(thumbnail, imageSrc, media.alt || '');
          }
        });
      });

      // Bind arrow navigation using your actual button classes
      let nextButtons = Array.from(this.modalContent.querySelectorAll('.gallery-nav-button--next'));
      let prevButtons = Array.from(this.modalContent.querySelectorAll('.gallery-nav-button--prev'));
      
      // Also look for buttons with onclick handlers separately
      const onclickButtons = this.modalContent.querySelectorAll('[onclick*="navigateGallery"]');
      onclickButtons.forEach(button => {
        const onclick = button.getAttribute('onclick') || '';
        if (onclick.includes('next')) {
          nextButtons.push(button);
        } else if (onclick.includes('prev')) {
          prevButtons.push(button);
        }
      });
      
      console.log(`Found ${nextButtons.length} next buttons and ${prevButtons.length} prev buttons`);
      
      nextButtons.forEach(button => {
        button.removeAttribute('onclick');
        // Remove all existing event listeners by cloning the element
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        console.log('Binding next button:', newButton);
        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('🔥 Next button clicked - EVENT FIRED');
          this.navigateGallery('next');
        }, { once: false });
      });
      
      prevButtons.forEach(button => {
        button.removeAttribute('onclick');
        // Remove all existing event listeners by cloning the element
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        console.log('Binding prev button:', newButton);
        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('🔥 Prev button clicked - EVENT FIRED');
          this.navigateGallery('prev');
        }, { once: false });
      });

      // Also try to find buttons by aria-label or text content as fallback
      const allButtons = this.modalContent.querySelectorAll('button');
      allButtons.forEach(button => {
        const ariaLabel = button.getAttribute('aria-label') || '';
        const textContent = button.textContent || '';
        
        if (ariaLabel.toLowerCase().includes('next') || textContent.toLowerCase().includes('next')) {
          button.removeAttribute('onclick');
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('➡️ Next button (by label) clicked');
            this.navigateGallery('next');
          });
        } else if (ariaLabel.toLowerCase().includes('prev') || textContent.toLowerCase().includes('prev') || 
                   ariaLabel.toLowerCase().includes('previous') || textContent.toLowerCase().includes('previous')) {
          button.removeAttribute('onclick');
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('⬅️ Prev button (by label) clicked');
            this.navigateGallery('prev');
          });
        }
      });

      // Bind thumbnail scroll buttons
      const thumbPrev = this.modalContent.querySelector('.thumb-prev');
      const thumbNext = this.modalContent.querySelector('.thumb-next');
      
      if (thumbPrev) {
        thumbPrev.removeAttribute('onclick');
        thumbPrev.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.scrollThumbnails('prev');
        });
      }
      
      if (thumbNext) {
        thumbNext.removeAttribute('onclick');
        thumbNext.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.scrollThumbnails('next');
        });
      }

      // Keyboard navigation (scoped to modal)
      this.keydownHandler = (e) => {
        // Only handle if modal is open
        if (!this.open) return;
        
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          console.log('⌨️ Left arrow key pressed');
          this.navigateGallery('prev');
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          console.log('⌨️ Right arrow key pressed');
          this.navigateGallery('next');
        }
      };
      
      document.addEventListener('keydown', this.keydownHandler);
      console.log('✅ Gallery events bound');
    }

    // Set active image in modal
    setActiveImage(thumbnail, imageSrc, imageAlt) {
      const mainImage = this.modalContent.querySelector('#main-gallery-image');
      if (mainImage) {
        mainImage.src = imageSrc;
        mainImage.alt = imageAlt;
      }
      
      // Update active thumbnail
      this.modalContent.querySelectorAll('.thumbnail-item').forEach(item => {
        item.classList.remove('active');
      });
      thumbnail.classList.add('active');
      
      // Update current index
      this.currentImageIndex = parseInt(thumbnail.dataset.mediaIndex);
    }

    // Navigate gallery with arrows in modal
    navigateGallery(direction) {
      console.log(`🧭 Navigating ${direction}, current index: ${this.currentImageIndex}`);
      console.log(`Gallery media array:`, this.galleryMedia);
      
      if (!this.galleryMedia || this.galleryMedia.length === 0) {
        console.log('❌ No gallery media available');
        return;
      }
      
      const totalImages = this.galleryMedia.length;
      console.log(`Total images: ${totalImages}`);
      
      if (direction === 'next') {
        this.currentImageIndex = (this.currentImageIndex + 1) % totalImages;
      } else {
        this.currentImageIndex = (this.currentImageIndex - 1 + totalImages) % totalImages;
      }
      
      console.log(`New index: ${this.currentImageIndex}`);
      
      const currentMedia = this.galleryMedia[this.currentImageIndex];
      
      if (!currentMedia) {
        console.log('❌ No media found at index:', this.currentImageIndex);
        return;
      }
      
      console.log('Current media:', currentMedia);
      
      const imageSrc = currentMedia.preview_image ? 
        currentMedia.preview_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_800x.$1') :
        currentMedia.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_800x.$1');
      
      console.log('Image src:', imageSrc);
      
      // Update main image
      const mainImage = this.modalContent.querySelector('#main-gallery-image');
      if (!mainImage) {
        const altImage = this.modalContent.querySelector('.product__media img');
        if (altImage) {
          altImage.src = imageSrc;
          altImage.alt = currentMedia.alt || '';
          console.log('✅ Alternative main image updated');
        }
      } else {
        mainImage.src = imageSrc;
        mainImage.alt = currentMedia.alt || '';
        console.log('✅ Main image updated');
      }
      
      // Update active thumbnail
      const thumbnails = this.modalContent.querySelectorAll('.thumbnail-item');
      thumbnails.forEach(item => item.classList.remove('active'));
      if (thumbnails[this.currentImageIndex]) {
        thumbnails[this.currentImageIndex].classList.add('active');
        
        // Scroll thumbnail into view
        thumbnails[this.currentImageIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        console.log('✅ Thumbnail updated and scrolled into view');
      }
    }

    // Scroll thumbnails in modal
    scrollThumbnails(direction) {
      const slider = this.modalContent.querySelector('#thumbnail-slider');
      if (!slider) return;
      
      const scrollAmount = 200;
      
      if (direction === 'next') {
        slider.scrollLeft += scrollAmount;
      } else {
        slider.scrollLeft -= scrollAmount;
      }
    }

    // Clean up event listeners when modal closes
    removeModalEventListeners() {
      if (this.keydownHandler) {
        document.removeEventListener('keydown', this.keydownHandler);
        this.keydownHandler = null;
      }
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Remove script tags to prevent conflicts and redeclaration errors
      // We'll handle the gallery functionality with our custom modal script
      element.querySelectorAll('script').forEach(script => {
        const content = script.textContent || script.innerText;
        
        // Only remove scripts that contain gallery-related variables that cause conflicts
        if (content.includes('currentImageIndex') || 
            content.includes('EnquiryModal') ||
            content.includes('initializeGallery') ||
            content.includes('navigateGallery')) {
          console.log('🗑️ Removing conflicting script tag');
          script.remove();
        } else {
          // Reinject non-conflicting scripts
          const newScriptTag = document.createElement('script');
          Array.from(script.attributes).forEach(attribute => {
            newScriptTag.setAttribute(attribute.name, attribute.value)
          });
          newScriptTag.appendChild(document.createTextNode(script.innerHTML));
          script.parentNode.replaceChild(newScriptTag, script);
        }
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;      
      variantPicker.setAttribute('data-update-url', 'false');
      
      $('input:radio[name="Color"]').click(function() {      
        $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
        $(this).next('.swatch-element').addClass('clicked');
      });
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();      
       
      const productEnquiry = this.productElement.querySelector('enquiryPopUp');
      if (productEnquiry) productEnquiry.remove();  

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach((modal) => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });      
    }

    removeGalleryListSemantic() {      
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');      
      if (!galleryList) return;     
      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      
      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');        
      if (FBT) FBT.remove();
      const Tabs = this.modalContent.querySelector('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
    }
  });
}